export const getDownloadButtonLabel = (selectedTenderResponses = []) => {
  switch (selectedTenderResponses.length) {
    case 0:
      return 'Download All Responses';
    default:
      return `Download selected Responses`;
  }
};
